"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _Select = _interopRequireDefault(require("../Select"));

var _Input = _interopRequireDefault(require("../Input"));

var _redux = require("../../redux"); // import app components


var TermForm = function TermForm(props) {
  var _site$languages, _site$languages2, _site$languages2$taxo, _site$languages3, _site$languages3$lang;

  var id = props.id,
      _props$title = props.title,
      defaultTitle = _props$title === void 0 ? '' : _props$title,
      _props$slug = props.slug,
      defaultSlug = _props$slug === void 0 ? '' : _props$slug,
      _props$parentID = props.parentID,
      defaultParentID = _props$parentID === void 0 ? 0 : _props$parentID,
      _props$description = props.description,
      defaultDescription = _props$description === void 0 ? '' : _props$description,
      _props$language = props.language,
      defaultLanguage = _props$language === void 0 ? '' : _props$language,
      taxonomyID = props.taxonomyID,
      terms = props.terms,
      onSubmit = props.onSubmit;

  var _ref = (0, _redux.useAppSelector)(function (state) {
    return state;
  }),
      _ref$cms = _ref.cms,
      site = _ref$cms.site,
      activeLanguage = _ref$cms.activeLanguage;

  var dispatch = (0, _redux.useAppDispatch)();
  var termExists = !!id;
  var initialLanguage = defaultLanguage ? defaultLanguage : activeLanguage === 'all' ? site === null || site === void 0 ? void 0 : (_site$languages = site.languages) === null || _site$languages === void 0 ? void 0 : _site$languages.defaultLanguage : activeLanguage;

  var _ref2 = (0, _react.useState)(defaultTitle),
      _ref3 = _slicedToArray(_ref2, 2),
      title = _ref3[0],
      setTitle = _ref3[1];

  var _ref4 = (0, _react.useState)(defaultSlug),
      _ref5 = _slicedToArray(_ref4, 2),
      slug = _ref5[0],
      setSlug = _ref5[1];

  var _ref6 = (0, _react.useState)(defaultParentID),
      _ref7 = _slicedToArray(_ref6, 2),
      parentID = _ref7[0],
      setParentID = _ref7[1];

  var _ref8 = (0, _react.useState)(defaultDescription),
      _ref9 = _slicedToArray(_ref8, 2),
      description = _ref9[0],
      setDescription = _ref9[1];

  var _ref10 = (0, _react.useState)(initialLanguage),
      _ref11 = _slicedToArray(_ref10, 2),
      language = _ref11[0],
      setLanguage = _ref11[1];

  var _ref12 = (0, _react.useState)(false),
      _ref13 = _slicedToArray(_ref12, 2),
      loading = _ref13[0],
      setLoading = _ref13[1]; // Check if taxonomy supports languages


  var taxonomySupportsLanguages = !!(site !== null && site !== void 0 && (_site$languages2 = site.languages) !== null && _site$languages2 !== void 0 && (_site$languages2$taxo = _site$languages2.taxonomies) !== null && _site$languages2$taxo !== void 0 && _site$languages2$taxo.find(function (s) {
    return s === taxonomyID;
  }));

  var handleSubmit = /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (title) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              setLoading(true);
              _context.next = 5;
              return onSubmit({
                id: id,
                title: title,
                slug: slug,
                parentID: parentID,
                description: description,
                language: language
              });

            case 5:
              setLoading(false);
              dispatch(_redux.uiActions.hideDialog());

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSubmit() {
      return _ref14.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 20
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical"
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: "Title",
    value: title,
    onChange: function onChange(e) {
      return setTitle(e.target.value);
    },
    onKeyDown: function onKeyDown(e) {
      return e.key === 'Enter' && handleSubmit();
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: "slug",
    value: slug,
    onChange: function onChange(e) {
      return setSlug(e.target.value);
    },
    onKeyDown: function onKeyDown(e) {
      return e.key === 'Enter' && handleSubmit();
    }
  }), taxonomySupportsLanguages && /*#__PURE__*/_react.default.createElement(_Select.default, {
    label: "Language",
    value: language,
    onChange: function onChange(value) {
      return setLanguage(value);
    }
  }, site === null || site === void 0 ? void 0 : (_site$languages3 = site.languages) === null || _site$languages3 === void 0 ? void 0 : (_site$languages3$lang = _site$languages3.languages) === null || _site$languages3$lang === void 0 ? void 0 : _site$languages3$lang.map(function (o) {
    return /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
      key: o.id,
      value: o.slug,
      children: o.name
    });
  })), /*#__PURE__*/_react.default.createElement(_Input.default, {
    rows: 4,
    label: "Description",
    value: description,
    allowClear: true,
    onChange: function onChange(e) {
      return setDescription(e.target.value);
    },
    onKeyDown: function onKeyDown(e) {
      return e.key === 'Enter' && handleSubmit();
    }
  }), /*#__PURE__*/_react.default.createElement(_Select.default, {
    value: parentID,
    onChange: function onChange(value) {
      return setParentID(value);
    },
    label: 'Parent'
  }, /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
    value: 0,
    children: "None"
  }), terms && Object.values(terms).filter(function (o) {
    return o.id !== id;
  }).map(function (o) {
    return /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
      key: o.id,
      value: o.id,
      children: o.title
    });
  }))), /*#__PURE__*/_react.default.createElement(_antd.Button, {
    children: termExists ? 'Update' : 'Add',
    onClick: handleSubmit,
    type: "primary",
    block: true,
    loading: loading
  }));
};

var _default = TermForm;
exports.default = _default;